
import DoctorsBanner from "../components/Doctors/DoctorsBanner";
import AllDoctors from "../components/Doctors/AllDoctors";

const DoctorsPage = () => {
  

  return (
    <>
      <DoctorsBanner/>
      <AllDoctors/>
    </>
  );
};

export default DoctorsPage;
